import { Component, OnInit } from "@angular/core";
import { Router } from "../../../../node_modules/@angular/router";
import { SessionStateService } from "../../core/services/session-state.service";
import { environment } from "../../../environments/environment";
import { GeneralService } from "../../shared/services/general.service";

@Component({
  selector: "app-footer-layout",
  templateUrl: "./footer-layout.component.html",
  styleUrls: ["./footer-layout.component.scss"],
})
export class FooterLayoutComponent implements OnInit {
  customerServiceNumber: string;

  constructor(
    private router: Router,
    private sessionStateService: SessionStateService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/footer-layout/footer-layout.component.ts